<template>
  <div class="m-search">
    <cube-input
      class="m-input"
      v-model="currentValue"
      :placeholder="placeholder"
      type="text"
      ref="input"
      @keyup.enter.native="submitHandle"
    >
      <img class="icon" alt="搜索" src="@/assets/iconSearch.png" slot="prepend" />
    </cube-input>
  </div>
</template>

<script>
import debounce from 'lodash/debounce';

export default {
  name: 'm-search',
  props: {
    value: {
      type: String,
      required: true,
      default: ''
    },
    placeholder: {
      type: String,
      default: '搜索'
    }
  },
  data() {
    return {
      currentValue: ''
    };
  },
  created() {
    if (this.value) {
      this.currentValue = this.value;
    }
  },
  methods: {
    setBlur() {
      // this.$refs.input.blur();
    },
    submitHandle() {
      this.$emit('submit', this.currentValue);
    },
    changeHandle: debounce(function() {
      this.$emit('changeValue', this.currentValue);
      this.$emit('submit', this.currentValue);
    }, 1000)
  },
  watch: {
    currentValue() {
      this.changeHandle();
    },
    value(val) {
      this.currentValue = val;
    }
  }
};
</script>

<style lang="less" scoped>
.m-search {
  // width: 100%;
  height: 40px;
  background-color: #f7f7f7;
  padding: 5px 0;

  .m-input {
    input {
      text-align: left !important;
    }

    .icon {
      width: 14px;
      height: 14px;
      margin-left: 10px;
    }
  }

  .cube-input::after {
    border-color: #fff;
  }
}
</style>
